export const googleAPIsURL = 'https://maps.googleapis.com'
export const googleAPIsURLs = {
  geocode: `${googleAPIsURL}/maps/api/geocode/json`,
}
